import * as React from "react";
import { Box } from "@material-ui/core";
import {
    ExportButton,
    FilterContext,
    ListBase,
    Pagination,
    ReferenceInput,
    SearchInput,
    SelectInput,
    Title,
    TopToolbar,
    useListContext,
} from "react-admin";

import GridList from "../itemsExtra/GridList";
import Aside from "../itemsExtra/Aside";



export const ItemFilters = [
    <SearchInput source="name" alwaysOn />,
    <ReferenceInput source="category_id" reference="categories" sort={{ field: "id", order: "ASC" }}>
        <SelectInput source="name" />
    </ReferenceInput>
];

const ListActions = () => (
    <TopToolbar>
        <ExportButton />
    </TopToolbar>
);

export const ItemList = (props) => {
    return (
        <ListBase perPage={20} {...props}>
            <ItemListView />
        </ListBase>
    );
};

const ItemListView = () => {
    const { defaultTitle } = useListContext();
    return (
        <>
            <Title defaultTitle={defaultTitle} />
            <FilterContext.Provider value={ItemFilters}>
                <ListActions />
            </FilterContext.Provider>
            <Box display="flex">
                <Aside />
                <Box width="calc(100% - 16em)">
                    <GridList />
                    <Pagination rowsPerPageOptions={[10, 20, 30]} />
                </Box>
            </Box>
        </>
    );
};
